'use client';

export const runtime = 'edge';


import { SimpleOopsFallback } from '@/components/errors/simple-oops-fallback';

export default function NotFound() {
  return <SimpleOopsFallback subtitle='Page not found.' />;
}
